var _path, _path2, _path3, _path4, _path5, _path6, _path7, _path8, _circle;
function _extends() { return _extends = Object.assign ? Object.assign.bind() : function (n) { for (var e = 1; e < arguments.length; e++) { var t = arguments[e]; for (var r in t) ({}).hasOwnProperty.call(t, r) && (n[r] = t[r]); } return n; }, _extends.apply(null, arguments); }
import * as React from "react";
function SvgVVqLeIav(_ref, svgRef) {
  let {
    title,
    titleId,
    ...props
  } = _ref;
  return /*#__PURE__*/React.createElement("svg", _extends({
    width: 26,
    height: 26,
    viewBox: "0 0 26 26",
    fill: "none",
    xmlns: "http://www.w3.org/2000/svg",
    ref: svgRef,
    "aria-labelledby": titleId
  }, props), title ? /*#__PURE__*/React.createElement("title", {
    id: titleId
  }, title) : null, _path || (_path = /*#__PURE__*/React.createElement("path", {
    d: "M6.6416 13.3884C7.48572 13.3287 8.3004 13.4814 8.93394 14.1193C9.37547 14.564 9.65126 15.1547 9.96464 15.7067C10.5787 16.7902 11.6696 17.2655 13.0006 17.2335",
    stroke: "#EE3D85",
    strokeWidth: 2,
    strokeLinecap: "round",
    strokeLinejoin: "round"
  })), _path2 || (_path2 = /*#__PURE__*/React.createElement("path", {
    d: "M7.95703 18.1146C9.04153 18.1179 10.096 17.4175 10.5125 16.416",
    stroke: "#EE3D85",
    strokeWidth: 2,
    strokeLinecap: "round",
    strokeLinejoin: "round"
  })), _path3 || (_path3 = /*#__PURE__*/React.createElement("path", {
    fillRule: "evenodd",
    clipRule: "evenodd",
    d: "M18.1399 10.778C16.6343 10.4437 16.6061 9.32425 15.7948 8.4924C15.0576 7.73597 13.9973 7.66397 13.0005 7.72311",
    fill: "#EE3D85"
  })), _path4 || (_path4 = /*#__PURE__*/React.createElement("path", {
    d: "M18.1399 10.778C16.6343 10.4437 16.6061 9.32425 15.7948 8.4924C15.0576 7.73597 13.9973 7.66397 13.0005 7.72311",
    stroke: "#EE3D85",
    strokeWidth: 2,
    strokeLinecap: "round",
    strokeLinejoin: "round"
  })), _path5 || (_path5 = /*#__PURE__*/React.createElement("path", {
    d: "M16.8604 18.115C16.8604 16.8344 17.8984 15.7964 19.1794 15.7964",
    stroke: "#EE3D85",
    strokeWidth: 2,
    strokeLinecap: "round",
    strokeLinejoin: "round"
  })), _path6 || (_path6 = /*#__PURE__*/React.createElement("path", {
    d: "M9.13345 7.33789C9.13345 8.61846 8.09545 9.65646 6.81445 9.65646",
    stroke: "#EE3D85",
    strokeWidth: 2,
    strokeLinecap: "round",
    strokeLinejoin: "round"
  })), _path7 || (_path7 = /*#__PURE__*/React.createElement("path", {
    fillRule: "evenodd",
    clipRule: "evenodd",
    d: "M25 12.515C25 10.8683 24.0873 9.39696 22.6327 8.62995C22.8099 7.62756 22.5822 6.60038 21.978 5.74093C21.3539 4.85353 20.4228 4.27185 19.3631 4.09103C19.2937 3.37092 18.9929 2.69454 18.487 2.14127C17.8232 1.4162 16.8704 1 15.8735 1C14.6853 1 13.6342 1.58033 13.0002 2.46548C12.3658 1.58033 11.3147 1 10.1265 1C9.12956 1 8.17678 1.4162 7.51348 2.14127C7.00755 2.69454 6.70634 3.37092 6.63735 4.09103C5.5777 4.27185 4.64611 4.85353 4.02249 5.74093C3.41826 6.60038 3.1901 7.62756 3.36731 8.62995C1.91265 9.39696 1 10.8683 1 12.515C1 13.9602 1.70343 15.2764 2.87671 16.0989C2.20169 17.1635 2.10023 18.445 2.6233 19.6512C3.2645 21.1298 4.70247 22.0853 6.28699 22.0853C6.41054 22.0853 6.53454 22.0794 6.65899 22.0681C6.75684 22.7242 7.04859 23.3469 7.50491 23.8497C8.16956 24.5806 9.12505 25 10.1265 25C11.3147 25 12.3658 24.4192 13.0002 23.5345C13.6342 24.4192 14.6853 25 15.8735 25C16.8749 25 17.8304 24.5811 18.4946 23.8497C18.9514 23.3469 19.2432 22.7247 19.341 22.0681C19.4655 22.0794 19.5895 22.0853 19.7126 22.0853H19.713C21.2975 22.0848 22.7359 21.1293 23.3772 19.6508C23.9002 18.4446 23.7983 17.1635 23.1233 16.0989C24.2966 15.2764 25 13.9602 25 12.515Z",
    stroke: "#644EB2",
    strokeWidth: 2,
    strokeLinecap: "round",
    strokeLinejoin: "round"
  })), _path8 || (_path8 = /*#__PURE__*/React.createElement("path", {
    d: "M13.0005 2.98779V23.1071",
    stroke: "#644EB2",
    strokeWidth: 2,
    strokeLinecap: "round",
    strokeLinejoin: "round"
  })), _circle || (_circle = /*#__PURE__*/React.createElement("circle", {
    cx: 20.4996,
    cy: 11.068,
    r: 0.9,
    fill: "#EE3D85"
  })));
}
const ForwardRef = /*#__PURE__*/React.forwardRef(SvgVVqLeIav);
export default __webpack_public_path__ + "static/media/VVqLEIav.a90db73002fb8d5f004655e2f20008bc.svg";
export { ForwardRef as ReactComponent };